<template>
	<div class="container" id="pointhistory">
		<SubpageHeader
			@on-back="actionBack"
		>
			ポイント確認
		</SubpageHeader>

		<div class="container-block">
			<div class="haspoint">
				<dl>
					<dt>保有ポイント</dt>
					<dd>{{textUfPoint}}</dd>
				</dl>
			</div>
			<HeaderCaption>UFポイント履歴</HeaderCaption>


			<table class="historypoint table table-bordered table-condensed">
				<tbody>
					<tr v-for="info,index in logPoint" :key="index">
						<td class="date">{{textDate(info)}}</td>
						<td class="tekiyo">{{textTekiyo(info)}}</td>
						<td class="zogen"><p><span :class="textZogenClass(info)">{{textZogen(info)}}</span></p></td>
					</tr>
				</tbody>
			</table>
		</div>

		<div class="row actioncmd marginBottom20">
			<div class="col-xs-12"><div class="text-center"><a href="mypage.php{if $link_user_id > 0}?user_id={$link_user_id}{/if}" class="btn btn-success btnSubmit">マイページトップへ戻る</a></div></div>
		</div>

	</div>
</template>
<script>
	import SubpageHeader from '@/components/SubpageHeader';
	import HeaderCaption from '@/components/common/HeaderCaption';
	import {addFigure} from '@/lib/formatter';

	export default {
		components: {
			SubpageHeader, HeaderCaption
		},
		props: {
		},
		data() {
			return {
			};
		},
		computed: {
			ufPoint() {
				return this.$store.getters['commonStore/getUfPoint'];
			},
			textUfPoint() {
				if(!this.ufPoint) return '0';
				if(!this.ufPoint.point) return '0';
				return addFigure(this.ufPoint.point);
			},
			logPoint() {
				return this.$store.getters['commonStore/getPointLog'];
			},
			isLogin() {
				return this.$store.getters['commonStore/isLogin'];
			},
		},
		methods: {
			actionBack() {
				this.$router.push('/top');
			},
			textDate(info) {
				if(!info.created) return '';
				return info.created.substr(0, 10);
			},
			textTekiyo(info) {
				let ret = '';
				if(info.entryname) ret += info.entryname+" ";
				if(info.classname) ret += info.classname+" ";
				return ret;
			},
			textZogenClass(info) {
				if(info.point_before < info.point_after) return 'zo';
				if(info.point_before > info.point_after) return 'gen';
				return '';
			},
			textZogen(info) {
				let ret = '';
				if(info.point_before < info.point_after) ret += '+';
				if(info.point_before > info.point_after) ret += '-';
				ret += addFigure(Math.abs(info.point_before-info.point_after));
				return ret;
			}
		},
		mounted() {
			if(!this.isLogin) {
				this.$router.push('/login');
				return;
			}
			this.$store.dispatch('commonStore/pointInfo');
		}
	};
</script>

<style lang="scss" scoped>
	#pointhistory {
		.container-block {
			padding: 8px;
			.haspoint {
				text-align: right;
				padding-right: 20px;
				dl {
					margin-bottom: 10px;
	
					dt {
						display: inline;
						border-bottom: solid 1px #ccc;
					}
					dd {
						display: inline;
						border-bottom: solid 1px #ccc;
						@media screen and (max-width: 320px) {
							padding: 0 15px;
						}
					}
				}
			}
			
			table.historypoint {
				table-layout: fixed;
				border: none;
				font-size: 12px;
				
				th {
					@media screen and (max-width: 420px) {
						padding-left: 2px;
						padding-right: 2px;
					}
				}
				
				td {
					border: none;
					text-align: center;
					box-sizing: border-box;
					border-bottom: solid 1px #eee;
					@media screen and (max-width: 420px) {
						padding-left: 2px;
						padding-right: 2px;
					}

					&.date {
						width: 96px;
						text-align: center;
					}
					&.zogen {
						width: 64px;

						p {
							width: 100%;
							margin: 0;
							text-align: right;
							padding-right: calc( 50% - 1em);
	
							.zo {
								color: #000;
								font-weight: bold;
							}
							.gen {
								color: #c92a20;
							}
						
						}
					}
					&.tekiyo {
						text-align: left;
					}
				}
			}

		}
	}
	

</style>